/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import moment from "moment";
import Chart from "chart.js";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import barchart from '../../custom_lib/AiCharts/craBarChart.vue';
// let testarray= [];
export default {
  name: "cradashboard",
  components: { VPagination, VueCal,barchart },
  async mounted() {
  try {
    // Initialize headers
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultdashboard = store.getters.getdefaultdashboard;
    this.sndcharts = null;
    
    // Get initial data
    this.roleprivileges = await store.getters.getRolesprivilegeData;
    this.valnow = await store.getters.getStudyIs;
    
    // Load all data in parallel for better performance
    await Promise.all([
      this.loadSiteRiskMetrics(),
      this.getCraScheduleList(),
      this.loadCraSchedule(),
      this.countofloadSiteRiskMetrics(),
      this.countofoverdueRiskMetrics(),
      this.getgraphdata(),
      this.loadHighRiskScoreChart() ]);
    
    console.log("All data loaded successfully");
    console.log("Graph data:", this.data);

  } catch (error) {
    console.error("Error in mounted hook:", error);
  }

  // Add event listener for study ID changes
  window.addEventListener("studyIdChanged", async (event) => {
    try {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.defaultdashboard = store.getters.getdefaultdashboard;
      this.roleprivileges = await store.getters.getRolesprivilegeData;
      this.valnow = await store.getters.getStudyIs;
      
      // Reload all data when study changes
      await Promise.all([
        this.loadSiteRiskMetrics(),
        this.getCraScheduleList(),
        this.loadCraSchedule(),
        this.countofloadSiteRiskMetrics(),
        this.countofoverdueRiskMetrics(),
        this.getgraphdata() ,
        this.loadHighRiskScoreChart()
      ]);
      
    } catch (error) {
      console.error("Error in studyIdChanged event:", error);
    }
  });
},
  // async mounted() {
 
  //   this.headerValues = {
  //     headers: {
  //       Authorization: "Bearer " + this.idToken,
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   this.defaultdate = localStorage.getItem("dateformat");
  //   window.addEventListener("studyIdChanged", async (event) => {
  //     this.defaultdashboard = store.getters.getdefaultdashboard;
  //     console.log("StudyIDChanged into" + event.detail.storage);
  //     // window.location.reload();
  //     // await this.loadstudy();
  //     this.roleprivileges = await store.getters.getRolesprivilegeData;
  //     this.valnow = await store.getters.getStudyIs;
  //     await this.loadSiteRiskMetrics();
  //     this.loadCraSchedule();

  //     this.getCraScheduleList();
  //     await this.countofloadSiteRiskMetrics();
  //     await this.getgraphdata();
      
  //   });
  //   this.defaultdashboard = store.getters.getdefaultdashboard;
  //   this.sndcharts = null;
  //   // await this.loadstudy();
  //   this.roleprivileges = await store.getters.getRolesprivilegeData;
  //   this.valnow = await store.getters.getStudyIs;
  //   await this.loadSiteRiskMetrics();
  //   this.getCraScheduleList();
  //   this.loadCraSchedule();

  //   await this.countofloadSiteRiskMetrics();
  // },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      selectedcolumnobj: { 'CRA Visit Type': true, 'Monitoring Mode': true, 'Planned Date': true, 'Triggered By': true, 'Status': true },
      // loadCraSchedule: false,
      sites: [],
      currentPage: 1,
      data: [],
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      SortProperty: "",
      SortOrder: 1,
      craScheduleList: [],
      legendButtonText: "Show KPI Legend",
      showLegend: false,

      loadingCraSchedule: false,
      selectedSite: null,
      craEvents: [],
      highriskcount: "",
      overduevisitscount: "",
        firstchart: {
        charttype: ""
      },
      firstbarchart: {
        dataseries: [],
        chartOptions: {}
      },
      highRiskChart: null,
      




    };
  },
  computed: {
    keyRisks() {
    if (!this.selectedSite || !Array.isArray(this.selectedSite.risks)) {
      return [];
    }

    return this.selectedSite.risks;
  }
  },
  watch: {
  data: {
    handler(newVal) {
      console.log('Data changed:', newVal);
      console.log('Data length:', newVal.length);
    },
    deep: true,
    immediate: true
  }
},
  methods: {
   async loadHighRiskScoreChart() {
  try {
    const studyId = store.getters.getStudyIs;
    const url = `${this.baseurl}/forms/cra/keyriskindicatormetricsforcravisit?studyId=${studyId}&isFlaged=true`;

    const res = await axios.get(url, this.headerValues);

    const apiData = Array.isArray(res.data?.entities)
      ? res.data.entities
      : [];

    if (!apiData.length) return;

    const RISK_ORDER = [
      "SAE Rate",
      "Timeliness of data entry (SAEs)",
      "Major Protocol Deviation Rate",
      "Query aging (critical DP)",
      "Missing visits",
      "Enrollment rate",
      "Subject discontinuation rate",
      "Site Issue Outlier"
    ];

    const sites = apiData.map(s =>
      String(s.siteCode || "").replace("Site ", "Site")
    );

    const datasets = [];

    RISK_ORDER.forEach(riskName => {
      const data = apiData.map(site => {
        const risk = site.risks?.find(
          r => r.riskName === riskName && r.isFlagged
        );
        return risk ? Number(risk.score) : null;
      });

      if (data.some(v => v !== null)) {
        datasets.push({
          label: riskName,
          data,
          backgroundColor: "#ff4d4f",
          barThickness: 18,
          maxBarThickness: 18,
          skipNull: true
        });
      }
    });

    console.log("Sites:", sites);
    console.log("Datasets:", datasets);

    this.renderScoreChart(sites, datasets);

  } catch (err) {
    console.error("Risk score chart error", err);
  }
},
toggleLegend() {
      const legend = document.getElementById("kpiLegend");

      if (!this.showLegend) {
        legend.style.display = "block";
        this.legendButtonText = "Hide KPI Legend";
        this.showLegend = true;
      } else {
        legend.style.display = "none";
        this.legendButtonText = "Show KPI Legend";
        this.showLegend = false;
      }
    },

    renderScoreChart(sites, datasets) {
      if (!this.$refs.highRiskBarChart) return;

      const ctx = this.$refs.highRiskBarChart.getContext("2d");

      if (this.highRiskChart) {
        this.highRiskChart.destroy();
      }

      this.highRiskChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: sites,
          datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: { label: ctx => `${ctx.dataset.label}: ${ctx.raw}` }
            }
          },
          scales: {
            xAxes: [{
              stacked: false,
              categoryPercentage: 0.7,
              barPercentage: 0.9,
              scaleLabel: {
                display: true,
                labelString: "Sites"
              }
            }],
            yAxes: [{
              stacked: false,
              ticks: {
                min: 0,
                max: 27,
                beginAtZero: true,
                stepSize: 5
              },
              scaleLabel: {
                display: true,
                labelString: "Risk Score"
              }
            }]
          },

        }

      });
    },
async loadSiteRiskMetrics() {
  try {
    const studyId = store.getters.getStudyIs;
    const url = `${this.baseurl}/forms/cra/keyriskindicatormetricsforcravisit?studyId=${studyId}&status=High`;

    const response = await axios.get(url, this.headerValues);

    const allSites = Array.isArray(response.data?.entities)
      ? response.data.entities
      : [];

    // Filter sites with status "High" and get the one with max siteScore
    const highStatusSites = allSites.filter(s => s.status === "High");
    const maxScoreSite = highStatusSites.length > 0
      ? highStatusSites.reduce((max, current) => 
          current.siteScore > max.siteScore ? current : max
        )
      : null;

    // Show only the site with max siteScore and High status
    this.sites = maxScoreSite ? [maxScoreSite] : [];
    this.selectedSite = maxScoreSite || null;

    console.log("Site Risk Metrics:", this.sites);

  } catch (error) {
    console.error("Error loading site risk metrics", error);
    this.sites = [];
    this.selectedSite = null;
  }
},

 async drilldowncurrentchartforbar(datafromchild){
      console.log("datafromchild",datafromchild);
      const lastkey = this.historykeys[this.historykeys.length - 1];
      if(this.historydata[lastkey].length != datafromchild.sortedData.length){
       this.historykeys.push(datafromchild.filterkeyword);
      this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
      this.data = this.historydata[datafromchild.filterkeyword];
      }
    },
async getgraphdata() {
  const idtoken = store.getters.getIdToken;
  const studyId = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseurl}/forms/cra/keyriskindicatormetricsforcravisit?studyId=${studyId}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("API Response:", res.data);

    const sites = Array.isArray(res.data?.entities)
      ? res.data.entities
      : [];

    this.data = sites.flatMap(site =>
      (site.risks || []).map(risk => ({
        siteCode: site.siteCode,
        riskIndicator: risk.riskName,
        score: Number(risk.score),
        riskLevelColor: risk.riskLevelColor,
        riskLevelLabel: risk.riskLevelLabel || risk.riskLevel
      }))
    );

    console.log("Graph data transformed:", this.data);
    console.log("Data length:", this.data.length);

  } catch (err) {
    console.error("Error in getgraphdata:", err);
    this.data = [];
  }
},


     secondchartchange(type) {
      this.formchart.charttype = type;
    },
async countofloadSiteRiskMetrics() {
  try {
    const studyId = store.getters.getStudyIs;
    const url = `${this.baseurl}/forms/cra/keyriskindicatormetricsforcravisit?studyId=${studyId}&status=High`;

    const response = await axios.get(url, this.headerValues);

    this.sites = Array.isArray(response.data?.entities)
      ? response.data.entities
      : [];

    console.log("Site Risk Metrics:", this.sites);

    this.highriskcount =
  response.data &&
  response.data.totalCount !== undefined &&
  response.data.totalCount !== null
    ? response.data.totalCount
    : this.sites.length;


    console.log("High Risk Count:", this.highriskcount);

  } catch (error) {
    console.error("Error loading site risk metrics", error);
    this.sites = [];
    this.highriskcount = 0;
  }
},

async countofoverdueRiskMetrics() {
  const idtoken = store.getters.getIdToken;
  const stdid = store.getters.getStudyIs;
  const emailId = await jwt_decode(idtoken).email;
  try {
    const res = await axios.get(
          `${this.baseurl}/forms/cra/craschedulelist`,
          {
            params: {
              StudyId: stdid,
              CraId: emailId,
              Status: "Overdue",
              pageindex: this.currentPage,
              pagesize: this.pageSize,
              SortProperty: this.SortProperty,
              SortOrder: this.SortOrder,
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.overduevisitscount = res.data.totalCount;

  } catch (error) {
    console.error("Error loading site risk metrics", error);
    this.sites = [];
    this.overduevisitscount = null;
  }
    },
    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    SortSelected(property) {
      console.log("SortPropChanged:", property);

      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0;
      }

      this.activeSortColumn = property;
      this.currentPage = 1;

      console.log(`Sorting by ${this.SortProperty}, order: ${this.SortOrder}`);

      this.getCraScheduleList();
    },


    async getCraScheduleList() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      const emailId = await jwt_decode(idtoken).email;

      this.loadingCraSchedule = true;

      try {
        const res = await axios.get(
          `${this.baseurl}/forms/cra/craschedulelist`,
          {
            params: {
              StudyId: stdid,
              CraId: emailId,
              pageindex: this.currentPage,
              pagesize: this.pageSize,
              SortProperty: this.SortProperty,
              SortOrder: this.SortOrder,
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.craScheduleList = res.data.results || []; this.totalCount = res.data.totalCount; this.totalPages = Math.ceil(this.totalCount / this.pageSize);

      } catch (err) {
        console.error("error in getCraScheduleList", err);
        this.craScheduleList = [];
      } finally {
        this.loadingCraSchedule = false;
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      await this.getCraScheduleList();
    },
// async loadCraSchedule() {
//   try {
//     const studyId = store.getters.getStudyIs;
//     const idtoken = store.getters.getIdToken;
//     const craId = jwt_decode(idtoken).email;

//     const url = `${this.baseurl}/forms/cra/craschedulelist?StudyId=${studyId}&CraId=${craId}`;
//     const response = await axios.get(url, this.headerValues);

//     const results = response.data?.results || [];
//     const grouped = {};

//     const addVisit = (dateValue, item, dateType) => {
//       if (!dateValue) return;

//       const date = moment(dateValue).format('YYYY-MM-DD');

//       if (!grouped[date]) {
//         grouped[date] = {
//           start: date,
//           end: date,
//           allDay: true,
//           visits: [],
//           class: 'multi-visit'
//         };
//       }

//       grouped[date].visits.push({
//         siteCode: item.siteCode,
//         monitoringMode: item.monitoringMode,
//         visitType: item.craVisitType,
//         dateType // Planned | Immediate
//       });
//     };

//     results.forEach(item => {
//   if (item.overridePlannedDate) {
//     addVisit(item.immediateDate, item, 'Immediate');
//   } else {
//     addVisit(item.plannedDate, item, 'Planned');
//     addVisit(item.immediateDate, item, 'Immediate');
//   }
// });


//     this.craEvents = Object.values(grouped);

//   } catch (e) {
//     console.error(e);
//     this.craEvents = [];
//   }
// },
async loadCraSchedule() {
  try {
    const studyId = store.getters.getStudyIs;
    const idtoken = store.getters.getIdToken;
    const craId = jwt_decode(idtoken).email;

    const url = `${this.baseurl}/forms/cra/craschedulelist?StudyId=${studyId}&CraId=${craId}`;
    const response = await axios.get(url, this.headerValues);

    const results = response.data?.results || [];
    const grouped = {};

    const addPlannedVisit = (dateValue, item) => {
      if (!dateValue) return;

      const date = moment(dateValue).format("YYYY-MM-DD");

      if (!grouped[date]) {
        grouped[date] = {
          start: date,
          end: date,
          allDay: true,
          visits: [],
          class: "multi-visit"
        };
      }

      grouped[date].visits.push({
        siteCode: item.siteCode,
        monitoringMode: item.monitoringMode,
        visitType: item.craVisitType
      });
    };

    results.forEach(item => {
      addPlannedVisit(item.plannedDate, item);
    });

    this.craEvents = Object.values(grouped);

  } catch (e) {
    console.error(e);
    this.craEvents = [];
  }
},



    mapMonitoringModeToClass(mode) {
      switch (mode) {
        case 'Onsite':
          return 'on-site';
        case 'Remote':
          return 'remote';
        case 'Hybrid':
          return 'hybrid';
        default:
          return 'on-site';
      }
    },
     async fetchHighRiskBySite() {
    try {
      const res = await axios.get(
        `${this.baseurl}/forms/cra/keyriskindicatorsbysite`,
        { params: { studyId: this.studyId } }
      );

      this.buildRiskVsSiteChart(res.data);
    } catch (e) {
      console.error("Failed to load risk chart", e);
    }
  },
    buildRiskVsSiteChart(apiData) {
    // 1. Collect sites
    const sites = apiData.map(s => s.siteCode);

    // 2. Initialize matrix: risk → site → 0
    const riskMatrix = {};
    RISK_ORDER.forEach(risk => {
      riskMatrix[risk] = {};
      sites.forEach(site => {
        riskMatrix[risk][site] = 0;
      });
    });

    // 3. Fill matrix if risk exists & flagged
    apiData.forEach(site => {
      site.risks.forEach(risk => {
        if (risk.isFlagged && riskMatrix[risk.riskName]) {
          riskMatrix[risk.riskName][site.siteCode] = Number(risk.value || 1);
        }
      });
    });

    // 4. Build Apex series (one series per SITE)
    const series = sites.map(site => ({
      name: site,
      data: RISK_ORDER.map(risk => riskMatrix[risk][site])
    }));

    // 5. Assign to chart
    this.firstbarchart = {
      dataseries: series,
      chartOptions: this.getRiskVsSiteOptions(RISK_ORDER)
    };

    this.firstchart.charttype = "barhorizondal";
  },
    getRiskVsSiteOptions(riskLabels) {
    return {
      chart: {
        type: "bar",
        stacked: false,
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "60%"
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: riskLabels,
        title: {
          text: "Sites"
        }
      },
      yaxis: {
        title: {
          text: ""
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "right"
      },
      colors: ["#ff4d4f", "#ff7875", "#ffa39e", "#ffccc7"],
      grid: {
        strokeDashArray: 4
      },
      tooltip: {
        shared: true,
        intersect: false
      }
    };
  },
  


  },
};